import React from 'react';
import { InvoiceTable } from '@css-xp/ppc-invoice-table';

export const CustomerAddressInvoicesSection = ({
  transactionAccountId,
  label,
  invoiceFilterOptions,
  shouldHideCustomiseView,
  showDownloadCSVButton,
  selectedInterfaceKey,
}: {
  transactionAccountId: string;
  label?: string;
  invoiceFilterOptions: Record<string, string>[];
  shouldHideCustomiseView?: boolean;
  showDownloadCSVButton?: boolean;
  selectedInterfaceKey?: string;
}) => {
  return (
    <InvoiceTable
      label={label}
      id={transactionAccountId}
      filters={invoiceFilterOptions}
      transactionAccountId={transactionAccountId}
      shouldHideCustomiseView={shouldHideCustomiseView}
      showDownloadCSVButton={showDownloadCSVButton}
      selectedInterfaceKey={selectedInterfaceKey}
    />
  );
};
